import { requestPost } from '@/common/request';

export interface associateTowerParams {}

export interface associateTowerRes {}

//会场运营 - 关联通天塔项目
export async function associateTower(params: associateTowerParams): Promise<associateTowerRes> {
  return await requestPost('/room/associateTower', params);
}
